import { render } from "./News02.vue?vue&type=template&id=2c2beb55&scoped=true"
import script from "./News02.vue?vue&type=script&lang=js"
export * from "./News02.vue?vue&type=script&lang=js"

import "./News02.vue?vue&type=style&index=0&id=2c2beb55&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2beb55"]])

export default __exports__